import { render } from "./DBox.vue?vue&type=template&id=0968603c&scoped=true&ts=true"
import script from "./DBox.vue?vue&type=script&lang=ts"
export * from "./DBox.vue?vue&type=script&lang=ts"

import "./DBox.vue?vue&type=style&index=0&id=0968603c&scoped=true&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\atlanta-fe-git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0968603c"]])

export default __exports__